/* tslint:disable:max-line-length */
import * as React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

interface ArrowIconProps extends SvgIconProps {
    size?: string
}

export function ScheduleIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 56 60" {...props}>
            <g fill="none" fillRule="evenodd">
                <path fill="#FF5364" d="M47 5v4h-7V5H16v4H9V5H1v11h54V5z" />
                <path fill="#F1E6B0" d="M9 16H1v43h54V16H16z" />
                <path
                    fill="#D8C460"
                    d="M38 32h7v-7h-7v7zm0 9h7v-7h-7v7zm0 9h7v-7h-7v7zm-9 0h7v-7h-7v7zm-9 0h7v-7h-7v7zm-9 0h7v-7h-7v7zm0-9h7v-7h-7v7zm0-9h7v-7h-7v7zm9 0h7v-7h-7v7zm0 9h7v-7h-7v7zm9 0h7v-7h-7v7zm0-9h7v-7h-7v7zm9-9H9v29h38V23h-9z"
                />
                <path fill="#35495E" d="M9 9h7V1H9zM40 9h7V1h-7z" />
                <path fill="#25C3AB" d="M29 41h7v-7h-7z" />
                <g stroke="#231117" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                    <path d="M9 9h7V1H9zM40 9h7V1h-7z" />
                    <path d="M47 5v4h-7V5H16v4H9V5H1v11h54V5z" />
                    <path d="M47 5v4h-7V5H16v4H9V5H1v54h54V5z" />
                </g>
            </g>
        </SvgIcon>
    )
}

export function ConnectIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 94 91" {...props}>
            <defs>
                <path id="a" d="M0 91h94V0H0z" />
            </defs>
            <g fill="none" fillRule="evenodd">
                <path fill="#BDC3C7" d="M1.567 64.328h90.866V1.569H1.567z" />
                <g>
                    <path
                        fill="#485762"
                        d="M51.7 76.994v4.8c0 .752-.61 1.36-1.36 1.36h-6.68a1.36 1.36 0 01-1.36-1.36v-4.8c-11.595.55-20.367 3.098-20.367 6.16 0 3.467 11.224 6.277 25.067 6.277s25.067-2.81 25.067-6.276c0-3.063-8.772-5.61-20.367-6.161"
                    />
                    <path
                        fill="#667D8C"
                        d="M50.34 83.155H43.66a1.36 1.36 0 01-1.359-1.362V64.328h9.4v17.465c0 .752-.609 1.362-1.36 1.362"
                    />
                    <mask id="b" fill="#fff">
                        <use xlinkHref="#a" />
                    </mask>
                    <path fill="#667D8C" d="M1.567 58.052h90.866V7.845H1.567z" mask="url(#b)" />
                    <path
                        fill="#0086B9"
                        d="M7.833 21.966c.401 0 .802-.154 1.108-.46l6.267-6.276a1.569 1.569 0 000-2.219 1.563 1.563 0 00-2.216 0l-6.266 6.276a1.569 1.569 0 001.107 2.679M7.833 29.81c.401 0 .802-.153 1.108-.46l3.133-3.137a1.569 1.569 0 000-2.219 1.563 1.563 0 00-2.215 0l-3.133 3.138a1.569 1.569 0 001.107 2.678M12.988 20.852a1.651 1.651 0 00-.455 1.114c0 .423.173.815.455 1.113.297.283.689.455 1.112.455.407 0 .815-.172 1.112-.455.282-.298.455-.706.455-1.113 0-.408-.173-.816-.455-1.114-.595-.581-1.645-.581-2.224 0M16.126 19.937a1.561 1.561 0 002.215 0l4.7-4.707a1.569 1.569 0 000-2.219 1.563 1.563 0 00-2.215 0l-4.7 4.707a1.569 1.569 0 000 2.219M20.826 20.856l-14.1 14.12a1.569 1.569 0 001.107 2.68c.401 0 .802-.155 1.108-.46l14.1-14.121a1.569 1.569 0 000-2.219 1.563 1.563 0 00-2.215 0M23.954 17.714a1.651 1.651 0 00-.454 1.114c0 .408.172.815.454 1.114.298.282.705.455 1.113.455.407 0 .814-.173 1.112-.455.282-.299.454-.706.454-1.114 0-.424-.172-.816-.454-1.114-.58-.58-1.645-.58-2.225 0M30.874 13.011a1.563 1.563 0 00-2.215 0l-1.567 1.57a1.569 1.569 0 001.108 2.678c.401 0 .802-.154 1.108-.46l1.566-1.57a1.569 1.569 0 000-2.218"
                        mask="url(#b)"
                    />
                    <path
                        stroke="#000"
                        strokeLinecap="round"
                        strokeWidth="2"
                        d="M50.34 83.155H43.66a1.36 1.36 0 01-1.359-1.362V64.328h9.4v17.465c0 .752-.609 1.362-1.36 1.362zM1.567 64.328h90.866V1.569H1.567z"
                        mask="url(#b)"
                    />
                    <path
                        stroke="#000"
                        strokeLinecap="round"
                        strokeWidth="2"
                        d="M51.7 76.994v4.8c0 .752-.61 1.36-1.36 1.36h-6.68a1.36 1.36 0 01-1.36-1.36v-4.8c-11.595.55-20.367 3.098-20.367 6.16 0 3.467 11.224 6.277 25.067 6.277s25.067-2.81 25.067-6.276c0-3.063-8.772-5.61-20.367-6.161zM1.567 7.845h90.866M1.567 58.052h90.866"
                        mask="url(#b)"
                    />
                </g>
                <path
                    fill="#ECF0F1"
                    d="M42.53 43.667l-5.8 3.139a5.19 5.19 0 00-.93.658A19.441 19.441 0 0048.317 52c4.734 0 9.071-1.681 12.443-4.473a5.227 5.227 0 00-1.023-.68l-6.21-3.082a2.349 2.349 0 01-1.31-2.103v-2.418c.174-.197.375-.45.587-.75a14.12 14.12 0 001.93-3.861c.798-.244 1.384-.974 1.384-1.842v-2.58c0-.57-.254-1.077-.65-1.431v-3.732s.772-5.808-7.151-5.808c-7.924 0-7.152 5.808-7.152 5.808v3.732c-.396.354-.65.862-.65 1.43v2.581c0 .68.36 1.278.899 1.624.649 2.807 2.351 4.829 2.351 4.829v2.358c0 .86-.473 1.653-1.234 2.065"
                />
                <path
                    fill="#CFDAE9"
                    d="M28.003 32.08c-.104 6.077 2.617 11.54 6.95 15.172.282-.246.586-.472.925-.656l5.818-3.158a2.365 2.365 0 001.238-2.078v-2.372s-1.707-2.034-2.359-4.859a1.946 1.946 0 01-.902-1.635v-2.597c0-.571.256-1.082.653-1.438v-3.755S39.55 18.86 47.5 18.86c7.949 0 7.175 5.844 7.175 5.844v3.755c.396.356.652.867.652 1.438v2.597a1.95 1.95 0 01-1.388 1.854 14.25 14.25 0 01-1.936 3.885 9.399 9.399 0 01-.59.755v2.433c0 .896.509 1.715 1.314 2.116l6.23 3.1c.374.187.711.421 1.023.683 4.202-3.489 6.916-8.704 7.017-14.577.184-10.72-8.396-19.557-19.163-19.74-10.769-.183-19.646 8.357-19.831 19.077z"
                />
                <path
                    stroke="#0D1D21"
                    d="M53.019 45.377a8.83 8.83 0 018.83-8.83c1.617 0 3.127.442 4.43 1.2.466-1.67.721-3.428.721-5.247C67 21.73 58.27 13 47.5 13S28 21.73 28 32.5 36.73 52 47.5 52c2.56 0 5.004-.499 7.244-1.395a8.78 8.78 0 01-1.725-5.228z"
                />
                <path
                    stroke="#0D1D21"
                    d="M53.784 45.448a8.7 8.7 0 01.134-1.471l-.424-.213a2.348 2.348 0 01-1.307-2.102v-2.418c.174-.197.374-.451.586-.75a14.114 14.114 0 001.926-3.861 1.938 1.938 0 001.381-1.843v-2.58c0-.568-.253-1.076-.649-1.43v-3.732s.771-5.808-7.138-5.808c-7.91 0-7.138 5.808-7.138 5.808v3.732a1.917 1.917 0 00-.649 1.43v2.58c0 .68.36 1.28.897 1.625.649 2.807 2.347 4.829 2.347 4.829v2.358a2.35 2.35 0 01-1.232 2.065l-5.789 3.139c-.34.184-.645.411-.929.658A19.388 19.388 0 0048.293 52c2.547 0 4.973-.502 7.2-1.39a8.658 8.658 0 01-1.709-5.162z"
                />
                <path fill="#27B99A" d="M70 44.5a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0" />
                <path
                    fill="#FFF"
                    d="M66.703 41.131a.668.668 0 00-.964.183l-3.874 5.885-2.733-2.373a.667.667 0 00-.974.102.761.761 0 00.095 1.03l3.313 2.875a.665.665 0 001.008-.147l4.302-6.536a.76.76 0 00-.173-1.019"
                />
                <path stroke="#231317" d="M70 44.5a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0z" />
            </g>
        </SvgIcon>
    )
}

export function ArrowDropDown(props: ArrowIconProps) {
    return (
        <SvgIcon {...props}>
            <path d="M7 10l5 5 5-5z" />
        </SvgIcon>
    )
}

export function ArrowDropUp(props: ArrowIconProps) {
    return (
        <SvgIcon {...props}>
            <path d="M7 14l5-5 5 5z" />
        </SvgIcon>
    )
}

export function PaymentProgress(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 64 91" {...props}>
            <defs>
                <path id="a" d="M0 91h63.602V0H0z" />
            </defs>
            <g fill="none" fillRule="evenodd">
                <path
                    fill="#874300"
                    d="M44.424 4.015V2.497c0-.838-.68-1.519-1.517-1.519H21.674c-.838 0-1.517.68-1.517 1.519v1.518H4.99a3.036 3.036 0 00-3.033 3.037v78.954a3.036 3.036 0 003.033 3.037h54.6a3.036 3.036 0 003.034-3.037V7.052a3.036 3.036 0 00-3.034-3.037H44.424z"
                />
                <path
                    fill="#002180"
                    d="M42.503 13.699H21.1c-.844 0-1.53-.658-1.53-1.468V3.425c0-.81.686-1.468 1.53-1.468h21.404c.844 0 1.53.658 1.53 1.468v8.806c0 .81-.686 1.468-1.53 1.468"
                />
                <path
                    fill="#F0E4B0"
                    d="M44.522 10.763v1.509a1.52 1.52 0 01-1.53 1.508H21.589a1.52 1.52 0 01-1.529-1.508v-1.509H9.357c-.846 0-1.529.676-1.529 1.509v69.392c0 .832.683 1.508 1.529 1.508h45.867c.845 0 1.529-.676 1.529-1.508V12.272c0-.833-.684-1.509-1.53-1.509H44.523z"
                />
                <mask id="b" fill="#fff">
                    <use xlinkHref="#a" />
                </mask>
                <path
                    fill="#D49018"
                    d="M14.84 28.376h12.395v-5.87H14.84v5.87zm13.944 2.936H13.291c-.857 0-1.55-.658-1.55-1.468v-8.806c0-.81.693-1.468 1.55-1.468h15.493c.857 0 1.55.657 1.55 1.468v8.806c0 .81-.693 1.468-1.55 1.468zM32.747 41.097H13.242c-.83 0-1.5-.658-1.5-1.468 0-.81.67-1.468 1.5-1.468h19.505c.83 0 1.5.658 1.5 1.468 0 .81-.67 1.468-1.5 1.468M29.806 46.968H13.247c-.832 0-1.505-.658-1.505-1.468 0-.81.673-1.468 1.505-1.468h16.56c.832 0 1.505.658 1.505 1.468 0 .81-.673 1.468-1.506 1.468M28.784 52.839H13.291c-.857 0-1.55-.658-1.55-1.468 0-.81.693-1.468 1.55-1.468h15.493c.857 0 1.55.658 1.55 1.468 0 .81-.693 1.468-1.55 1.468M42.468 52.839a1.6 1.6 0 01-1.254-.587l-4.696-5.87c-.52-.65-.379-1.57.313-2.055.692-.489 1.673-.355 2.192.293l4.696 5.87c.52.65.378 1.57-.313 2.055-.282.198-.611.294-.938.294"
                    mask="url(#b)"
                />
                <path
                    fill="#D49018"
                    d="M42.633 52.839c-.31 0-.622-.093-.892-.283a1.512 1.512 0 01-.357-2.124l7.687-10.655a1.55 1.55 0 012.145-.355c.69.489.852 1.44.357 2.124L43.884 52.2a1.54 1.54 0 01-1.251.638M32.747 61.645H13.242c-.83 0-1.5-.657-1.5-1.468 0-.81.67-1.467 1.5-1.467h19.505c.83 0 1.5.657 1.5 1.467s-.67 1.468-1.5 1.468M29.806 68.495H13.247c-.832 0-1.505-.658-1.505-1.468 0-.81.673-1.468 1.505-1.468h16.56c.832 0 1.505.658 1.505 1.468 0 .81-.673 1.468-1.506 1.468M28.784 74.366H13.291c-.857 0-1.55-.658-1.55-1.468 0-.81.693-1.468 1.55-1.468h15.493c.857 0 1.55.658 1.55 1.468 0 .81-.693 1.468-1.55 1.468M42.468 74.366a1.6 1.6 0 01-1.254-.587l-4.696-5.87c-.52-.65-.379-1.57.313-2.055.692-.489 1.673-.355 2.192.293l4.696 5.87c.52.65.378 1.57-.313 2.055-.282.198-.611.294-.938.294"
                    mask="url(#b)"
                />
                <path
                    fill="#D49018"
                    d="M42.633 74.366c-.31 0-.622-.093-.892-.284a1.512 1.512 0 01-.357-2.123l7.687-10.655a1.55 1.55 0 012.145-.355c.69.489.852 1.44.357 2.124l-7.689 10.655a1.54 1.54 0 01-1.251.638"
                    mask="url(#b)"
                />
                <path
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M42.503 13.699H21.1c-.844 0-1.53-.658-1.53-1.468V3.425c0-.81.686-1.468 1.53-1.468h21.404c.844 0 1.53.658 1.53 1.468v8.806c0 .81-.686 1.468-1.53 1.468z"
                    mask="url(#b)"
                />
                <path
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M44.424 4.015V2.497c0-.838-.68-1.519-1.517-1.519H21.674c-.838 0-1.517.68-1.517 1.519v1.518H4.99a3.036 3.036 0 00-3.033 3.037v78.954a3.036 3.036 0 003.033 3.037h54.6a3.036 3.036 0 003.034-3.037V7.052a3.036 3.036 0 00-3.034-3.037H44.424z"
                    mask="url(#b)"
                />
                <path
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M44.522 10.763v1.509a1.52 1.52 0 01-1.53 1.508H21.589a1.52 1.52 0 01-1.529-1.508v-1.509H9.357c-.846 0-1.529.676-1.529 1.509v69.392c0 .832.683 1.508 1.529 1.508h45.867c.845 0 1.529-.676 1.529-1.508V12.272c0-.833-.684-1.509-1.53-1.509H44.523z"
                    mask="url(#b)"
                />
                <path
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13.699 30.333h14.677v-8.806H13.699z"
                    mask="url(#b)"
                />
            </g>
        </SvgIcon>
    )
}

export function PaymentVerified(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 64 91" {...props}>
            <defs>
                <path id="a" d="M0 91h63.602V0H0z" />
            </defs>
            <g fill="none" fill-rule="evenodd">
                <g opacity=".1">
                    <path
                        fill="#874300"
                        d="M44.424 4.015V2.497c0-.838-.68-1.519-1.517-1.519H21.674c-.838 0-1.517.68-1.517 1.519v1.518H4.99a3.036 3.036 0 00-3.033 3.037v78.954a3.036 3.036 0 003.033 3.037h54.6a3.036 3.036 0 003.034-3.037V7.052a3.036 3.036 0 00-3.034-3.037H44.424z"
                    />
                    <path
                        fill="#002180"
                        d="M42.503 13.699H21.1c-.844 0-1.53-.658-1.53-1.468V3.425c0-.81.686-1.468 1.53-1.468h21.404c.844 0 1.53.658 1.53 1.468v8.806c0 .81-.686 1.468-1.53 1.468"
                    />
                    <path
                        fill="#F0E4B0"
                        d="M44.522 10.763v1.509a1.52 1.52 0 01-1.53 1.508H21.589a1.52 1.52 0 01-1.529-1.508v-1.509H9.357c-.846 0-1.529.676-1.529 1.509v69.392c0 .832.683 1.508 1.529 1.508h45.867c.845 0 1.529-.676 1.529-1.508V12.272c0-.833-.684-1.509-1.53-1.509H44.523z"
                    />
                    <mask id="b" fill="#fff">
                        <use xlinkHref="#a" />
                    </mask>
                    <path
                        fill="#D49018"
                        d="M14.84 28.376h12.395v-5.87H14.84v5.87zm13.944 2.936H13.291c-.857 0-1.55-.658-1.55-1.468v-8.806c0-.81.693-1.468 1.55-1.468h15.493c.857 0 1.55.657 1.55 1.468v8.806c0 .81-.693 1.468-1.55 1.468zM32.747 41.097H13.242c-.83 0-1.5-.658-1.5-1.468 0-.81.67-1.468 1.5-1.468h19.505c.83 0 1.5.658 1.5 1.468 0 .81-.67 1.468-1.5 1.468M29.806 46.968H13.247c-.832 0-1.505-.658-1.505-1.468 0-.81.673-1.468 1.505-1.468h16.56c.832 0 1.505.658 1.505 1.468 0 .81-.673 1.468-1.506 1.468M28.784 52.839H13.291c-.857 0-1.55-.658-1.55-1.468 0-.81.693-1.468 1.55-1.468h15.493c.857 0 1.55.658 1.55 1.468 0 .81-.693 1.468-1.55 1.468M42.468 52.839a1.6 1.6 0 01-1.254-.587l-4.696-5.87c-.52-.65-.379-1.57.313-2.055.692-.489 1.673-.355 2.192.293l4.696 5.87c.52.65.378 1.57-.313 2.055-.282.198-.611.294-.938.294"
                        mask="url(#b)"
                    />
                    <path
                        fill="#D49018"
                        d="M42.633 52.839c-.31 0-.622-.093-.892-.283a1.512 1.512 0 01-.357-2.124l7.687-10.655a1.55 1.55 0 012.145-.355c.69.489.852 1.44.357 2.124L43.884 52.2a1.54 1.54 0 01-1.251.638M32.747 61.645H13.242c-.83 0-1.5-.657-1.5-1.468 0-.81.67-1.467 1.5-1.467h19.505c.83 0 1.5.657 1.5 1.467s-.67 1.468-1.5 1.468M29.806 68.495H13.247c-.832 0-1.505-.658-1.505-1.468 0-.81.673-1.468 1.505-1.468h16.56c.832 0 1.505.658 1.505 1.468 0 .81-.673 1.468-1.506 1.468M28.784 74.366H13.291c-.857 0-1.55-.658-1.55-1.468 0-.81.693-1.468 1.55-1.468h15.493c.857 0 1.55.658 1.55 1.468 0 .81-.693 1.468-1.55 1.468M42.468 74.366a1.6 1.6 0 01-1.254-.587l-4.696-5.87c-.52-.65-.379-1.57.313-2.055.692-.489 1.673-.355 2.192.293l4.696 5.87c.52.65.378 1.57-.313 2.055-.282.198-.611.294-.938.294"
                        mask="url(#b)"
                    />
                    <path
                        fill="#D49018"
                        d="M42.633 74.366c-.31 0-.622-.093-.892-.284a1.512 1.512 0 01-.357-2.123l7.687-10.655a1.55 1.55 0 012.145-.355c.69.489.852 1.44.357 2.124l-7.689 10.655a1.54 1.54 0 01-1.251.638"
                        mask="url(#b)"
                    />
                    <path
                        stroke="#000"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M42.503 13.699H21.1c-.844 0-1.53-.658-1.53-1.468V3.425c0-.81.686-1.468 1.53-1.468h21.404c.844 0 1.53.658 1.53 1.468v8.806c0 .81-.686 1.468-1.53 1.468z"
                        mask="url(#b)"
                    />
                    <path
                        stroke="#000"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M44.424 4.015V2.497c0-.838-.68-1.519-1.517-1.519H21.674c-.838 0-1.517.68-1.517 1.519v1.518H4.99a3.036 3.036 0 00-3.033 3.037v78.954a3.036 3.036 0 003.033 3.037h54.6a3.036 3.036 0 003.034-3.037V7.052a3.036 3.036 0 00-3.034-3.037H44.424z"
                        mask="url(#b)"
                    />
                    <path
                        stroke="#000"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M44.522 10.763v1.509a1.52 1.52 0 01-1.53 1.508H21.589a1.52 1.52 0 01-1.529-1.508v-1.509H9.357c-.846 0-1.529.676-1.529 1.509v69.392c0 .832.683 1.508 1.529 1.508h45.867c.845 0 1.529-.676 1.529-1.508V12.272c0-.833-.684-1.509-1.53-1.509H44.523z"
                        mask="url(#b)"
                    />
                    <path
                        stroke="#000"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13.699 30.333h14.677v-8.806H13.699z"
                        mask="url(#b)"
                    />
                </g>
                <path
                    fill="#3DA50C"
                    d="M62 47.5C62 63.792 48.792 77 32.5 77S3 63.792 3 47.5 16.208 18 32.5 18 62 31.208 62 47.5"
                />
                <path
                    stroke="#FFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M47.726 36.081l-18.74 20.935-11.712-9.305"
                />
                <path
                    stroke="#231117"
                    strokeWidth="2"
                    d="M62 47.5C62 63.792 48.792 77 32.5 77S3 63.792 3 47.5 16.208 18 32.5 18 62 31.208 62 47.5z"
                />
            </g>
        </SvgIcon>
    )
}
export function PaymentCanceled(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 64 91" {...props}>
            <defs>
                <path id="a" d="M0 91h63.602V0H0z" />
            </defs>
            <g fill="none" fillRule="evenodd">
                <g opacity=".1">
                    <path
                        fill="#874300"
                        d="M44.424 4.015V2.497c0-.838-.68-1.519-1.517-1.519H21.674c-.838 0-1.517.68-1.517 1.519v1.518H4.99a3.036 3.036 0 00-3.033 3.037v78.954a3.036 3.036 0 003.033 3.037h54.6a3.036 3.036 0 003.034-3.037V7.052a3.036 3.036 0 00-3.034-3.037H44.424z"
                    />
                    <path
                        fill="#002180"
                        d="M42.503 13.699H21.1c-.844 0-1.53-.658-1.53-1.468V3.425c0-.81.686-1.468 1.53-1.468h21.404c.844 0 1.53.658 1.53 1.468v8.806c0 .81-.686 1.468-1.53 1.468"
                    />
                    <path
                        fill="#F0E4B0"
                        d="M44.522 10.763v1.509a1.52 1.52 0 01-1.53 1.508H21.589a1.52 1.52 0 01-1.529-1.508v-1.509H9.357c-.846 0-1.529.676-1.529 1.509v69.392c0 .832.683 1.508 1.529 1.508h45.867c.845 0 1.529-.676 1.529-1.508V12.272c0-.833-.684-1.509-1.53-1.509H44.523z"
                    />
                    <mask id="b" fill="#fff">
                        <use xlinkHref="#a" />
                    </mask>
                    <path
                        fill="#D49018"
                        d="M14.84 28.376h12.395v-5.87H14.84v5.87zm13.944 2.936H13.291c-.857 0-1.55-.658-1.55-1.468v-8.806c0-.81.693-1.468 1.55-1.468h15.493c.857 0 1.55.657 1.55 1.468v8.806c0 .81-.693 1.468-1.55 1.468zM32.747 41.097H13.242c-.83 0-1.5-.658-1.5-1.468 0-.81.67-1.468 1.5-1.468h19.505c.83 0 1.5.658 1.5 1.468 0 .81-.67 1.468-1.5 1.468M29.806 46.968H13.247c-.832 0-1.505-.658-1.505-1.468 0-.81.673-1.468 1.505-1.468h16.56c.832 0 1.505.658 1.505 1.468 0 .81-.673 1.468-1.506 1.468M28.784 52.839H13.291c-.857 0-1.55-.658-1.55-1.468 0-.81.693-1.468 1.55-1.468h15.493c.857 0 1.55.658 1.55 1.468 0 .81-.693 1.468-1.55 1.468M42.468 52.839a1.6 1.6 0 01-1.254-.587l-4.696-5.87c-.52-.65-.379-1.57.313-2.055.692-.489 1.673-.355 2.192.293l4.696 5.87c.52.65.378 1.57-.313 2.055-.282.198-.611.294-.938.294"
                        mask="url(#b)"
                    />
                    <path
                        fill="#D49018"
                        d="M42.633 52.839c-.31 0-.622-.093-.892-.283a1.512 1.512 0 01-.357-2.124l7.687-10.655a1.55 1.55 0 012.145-.355c.69.489.852 1.44.357 2.124L43.884 52.2a1.54 1.54 0 01-1.251.638M32.747 61.645H13.242c-.83 0-1.5-.657-1.5-1.468 0-.81.67-1.467 1.5-1.467h19.505c.83 0 1.5.657 1.5 1.467s-.67 1.468-1.5 1.468M29.806 68.495H13.247c-.832 0-1.505-.658-1.505-1.468 0-.81.673-1.468 1.505-1.468h16.56c.832 0 1.505.658 1.505 1.468 0 .81-.673 1.468-1.506 1.468M28.784 74.366H13.291c-.857 0-1.55-.658-1.55-1.468 0-.81.693-1.468 1.55-1.468h15.493c.857 0 1.55.658 1.55 1.468 0 .81-.693 1.468-1.55 1.468M42.468 74.366a1.6 1.6 0 01-1.254-.587l-4.696-5.87c-.52-.65-.379-1.57.313-2.055.692-.489 1.673-.355 2.192.293l4.696 5.87c.52.65.378 1.57-.313 2.055-.282.198-.611.294-.938.294"
                        mask="url(#b)"
                    />
                    <path
                        fill="#D49018"
                        d="M42.633 74.366c-.31 0-.622-.093-.892-.284a1.512 1.512 0 01-.357-2.123l7.687-10.655a1.55 1.55 0 012.145-.355c.69.489.852 1.44.357 2.124l-7.689 10.655a1.54 1.54 0 01-1.251.638"
                        mask="url(#b)"
                    />
                    <path
                        stroke="#000"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M42.503 13.699H21.1c-.844 0-1.53-.658-1.53-1.468V3.425c0-.81.686-1.468 1.53-1.468h21.404c.844 0 1.53.658 1.53 1.468v8.806c0 .81-.686 1.468-1.53 1.468z"
                        mask="url(#b)"
                    />
                    <path
                        stroke="#000"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M44.424 4.015V2.497c0-.838-.68-1.519-1.517-1.519H21.674c-.838 0-1.517.68-1.517 1.519v1.518H4.99a3.036 3.036 0 00-3.033 3.037v78.954a3.036 3.036 0 003.033 3.037h54.6a3.036 3.036 0 003.034-3.037V7.052a3.036 3.036 0 00-3.034-3.037H44.424z"
                        mask="url(#b)"
                    />
                    <path
                        stroke="#000"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M44.522 10.763v1.509a1.52 1.52 0 01-1.53 1.508H21.589a1.52 1.52 0 01-1.529-1.508v-1.509H9.357c-.846 0-1.529.676-1.529 1.509v69.392c0 .832.683 1.508 1.529 1.508h45.867c.845 0 1.529-.676 1.529-1.508V12.272c0-.833-.684-1.509-1.53-1.509H44.523z"
                        mask="url(#b)"
                    />
                    <path
                        stroke="#000"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13.699 30.333h14.677v-8.806H13.699z"
                        mask="url(#b)"
                    />
                </g>
                <path
                    fill="#C82323"
                    d="M62 47.5C62 63.792 48.792 77 32.5 77S3 63.792 3 47.5 16.208 18 32.5 18 62 31.208 62 47.5"
                />
                <path
                    stroke="#FFF"
                    strokeLinecap="round"
                    strokeWidth="2"
                    d="M23 59l10.5-10.5L44 38M23 38l10.5 10.5L44 59"
                />
                <path
                    stroke="#231117"
                    strokeWidth="2"
                    d="M62 47.5C62 63.792 48.792 77 32.5 77S3 63.792 3 47.5 16.208 18 32.5 18 62 31.208 62 47.5z"
                />
            </g>
        </SvgIcon>
    )
}
export function SimplifeyeVyneLogo(props: SvgIconProps) {
    return (
        <svg
            width={props.width || 132}
            height={props.height || 32}
            viewBox="0 0 132 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g style={{ WebkitClipPath: 'url(#clip0_743_4222)', clipPath: 'url(#clip0_743_4222)' }}>
                <g style={{ WebkitClipPath: 'url(#clip1_743_4222)', clipPath: 'url(#clip1_743_4222)' }}>
                    <path
                        d="M51.3579 32.1441H122.044C127.586 32.1441 132.073 27.6571 132.073 22.1153V0H61.3867C55.8449 0 51.3579 4.48703 51.3579 10.0288V32.1441Z"
                        fill="url(#paint0_linear_743_4222)"
                    />
                    <path d="M132.073 0H51.3579V32.1441H132.073V0Z" fill="url(#paint1_linear_743_4222)" />
                    <path
                        d="M113.251 21.5706C113.346 21.5446 114.6 21.2074 114.66 21.2074C114.773 21.2074 114.928 21.2247 114.972 21.3458C114.989 21.3804 114.989 21.4236 114.998 21.4582C115.006 21.51 115.023 21.5706 115.041 21.6224C115.11 21.8472 115.214 22.072 115.343 22.2708C115.49 22.4783 115.672 22.6599 115.879 22.8069C115.94 22.8501 116 22.8847 116.07 22.9279C116.839 23.3602 117.721 23.5763 118.603 23.4899C119.191 23.438 119.882 23.2824 120.358 22.9106C121.015 22.3919 121.274 21.3717 120.721 20.6887C120.574 20.5072 120.384 20.3688 120.176 20.2737C119.588 20.0144 118.949 19.8933 118.326 19.7377C117.427 19.5043 116.51 19.3487 115.629 19.072C114.695 18.778 113.96 18.1988 113.692 17.2046C113.329 15.8559 113.917 14.4293 115.119 13.7118C116.139 13.0979 117.263 12.9423 118.421 13.0288C119.459 13.1066 120.418 13.3919 121.24 14.0576C121.905 14.6023 122.329 15.2853 122.536 16.1671C121.974 16.2881 121.43 16.4092 120.885 16.5302C120.859 16.4697 120.833 16.4351 120.825 16.4005C120.608 15.536 120.055 14.9654 119.234 14.6714C118.291 14.3429 117.34 14.3256 116.407 14.7233C115.923 14.9308 115.568 15.2853 115.412 15.7953C115.162 16.634 115.49 17.3342 116.32 17.6282C116.874 17.827 117.461 17.9394 118.041 18.0778C118.897 18.2853 119.77 18.4409 120.608 18.7175C121.196 18.9077 121.758 19.2103 122.156 19.6945C122.571 20.1959 122.753 20.853 122.753 21.5014C122.753 21.8731 122.683 22.2536 122.562 22.608C122.459 22.9106 122.312 23.1873 122.113 23.438C121.672 24 121.032 24.3631 120.375 24.5878C119.147 25.0115 117.799 25.0893 116.545 24.778C116.191 24.6916 115.836 24.5706 115.499 24.4322C115.309 24.3544 115.127 24.2593 114.954 24.1642C114.781 24.0691 114.617 23.9567 114.461 23.8357C114.306 23.7146 114.159 23.585 114.029 23.438C113.891 23.291 113.77 23.1354 113.666 22.9625C113.554 22.7809 113.459 22.5821 113.389 22.3832C113.381 22.3573 113.372 22.3227 113.364 22.2968C113.346 22.2363 113.329 22.1757 113.32 22.1152C113.303 22.0374 113.277 21.951 113.26 21.8731C113.242 21.804 113.234 21.7348 113.225 21.6657C113.225 21.6484 113.217 21.6224 113.225 21.6051C113.208 21.5878 113.234 21.5792 113.251 21.5706Z"
                        fill="white"
                    />
                    <path
                        d="M64.4642 13.2708C65.8216 13.2708 67.1443 13.2708 68.5103 13.2708C68.5103 13.7463 68.519 14.2045 68.5017 14.6541C68.5017 14.6973 68.3374 14.7579 68.251 14.7579C67.1184 14.7665 65.9772 14.7665 64.8446 14.7665C64.7409 14.7665 64.6285 14.7665 64.4902 14.7665C64.4815 14.8702 64.4729 14.9654 64.4729 15.0605C64.4729 17.0057 64.4729 18.9423 64.4729 20.8875C64.4729 21.1383 64.4815 21.389 64.5334 21.6397C64.7668 22.8069 65.6833 23.4466 66.8763 23.2737C67.1616 23.2305 67.4383 23.1527 67.7063 23.0489C67.9743 22.9452 68.2164 22.7896 68.5103 22.6426C68.6487 22.9884 68.7956 23.3429 68.934 23.6973C69.081 24.0777 69.0809 24.0691 68.7265 24.2939C67.568 25.0201 66.3317 25.1411 65.0435 24.7521C63.6861 24.3371 62.9772 23.3429 62.7611 21.9769C62.7005 21.5965 62.6919 21.2074 62.6919 20.8184C62.6833 18.9164 62.6919 17.023 62.6919 15.121C62.6919 15.0172 62.6919 14.9048 62.6919 14.7665C61.8619 14.7665 61.0493 14.7665 60.2366 14.7665C60.2366 14.2564 60.2366 13.7809 60.2366 13.2881C61.0493 13.2881 61.8446 13.2881 62.6919 13.2881C62.6919 13.1584 62.6919 13.0547 62.6919 12.9509C62.6919 11.8184 62.6919 10.6858 62.6919 9.55325C62.6919 9.20742 62.6919 9.20742 63.0464 9.20742C63.4181 9.20742 63.7899 9.22472 64.153 9.19878C64.3951 9.19013 64.4815 9.25065 64.4729 9.51002C64.4556 10.6512 64.4642 11.7924 64.4642 12.9337C64.4642 13.0374 64.4642 13.1411 64.4642 13.2708Z"
                        fill="white"
                    />
                    <path
                        d="M98.5017 22.9107C98.6227 23.3862 98.7351 23.8271 98.8389 24.268C98.8475 24.3199 98.7957 24.4063 98.7524 24.4323C97.5161 25.2017 95.519 25.1499 94.5075 23.9654C94.0925 23.4726 93.8677 22.902 93.8072 22.2709C93.7812 22.0461 93.7813 21.8213 93.7813 21.5966C93.7813 16.8242 93.7813 12.3545 93.7813 7.5735C93.7813 7.18445 93.7812 7.18445 94.1789 7.18445C94.5593 7.18445 94.9397 7.19309 95.3115 7.18445C95.4758 7.18445 95.5449 7.23632 95.5276 7.40059C95.519 7.52162 95.5276 7.65131 95.5276 7.78099C95.5276 12.5101 95.5276 16.9366 95.5276 21.6657C95.5276 22.6427 96.1328 23.2651 97.1098 23.2478C97.4815 23.2392 97.8446 23.1095 98.2164 23.0231C98.2942 23.0144 98.3807 22.9625 98.5017 22.9107Z"
                        fill="white"
                    />
                    ""
                    <path
                        d="M105.712 22.9106C105.833 23.3775 105.945 23.8098 106.041 24.2507C106.058 24.3026 106.006 24.4063 105.954 24.4409C104.7 25.219 102.677 25.1585 101.675 23.9308C101.234 23.3861 101.026 22.755 100.992 22.0634C100.983 21.9078 100.983 21.7608 100.983 21.6052C100.983 16.8242 100.983 14.3429 100.983 9.56194C100.983 9.19019 100.983 9.19019 101.346 9.19019C101.744 9.19019 102.141 9.19883 102.539 9.19019C102.686 9.19019 102.755 9.24206 102.747 9.38903C102.738 9.46684 102.747 9.5533 102.747 9.63111C102.747 14.3516 102.747 16.7723 102.747 21.4928C102.747 21.7176 102.747 21.9423 102.798 22.1671C102.937 22.7983 103.464 23.2046 104.173 23.2651C104.7 23.3083 105.193 23.1441 105.712 22.9106Z"
                        fill="white"
                    />
                    <path
                        d="M73.1011 24.6398C72.496 24.6398 71.934 24.6398 71.3375 24.6398C71.3288 24.5447 71.3202 24.4496 71.3202 24.3631C71.3202 20.7666 71.3202 17.1701 71.3115 13.5735C71.3115 13.3401 71.372 13.2623 71.6141 13.2709C72.0291 13.2882 72.4441 13.2882 72.8591 13.2709C73.0493 13.2623 73.1098 13.3314 73.1098 13.5216C73.1011 14.2565 73.1011 15 73.1098 15.7349C73.1098 15.8041 73.1271 15.8732 73.1357 15.9597C73.3864 15.6139 73.6026 15.2853 73.8533 14.9827C74.9081 13.7378 76.2481 13.1153 77.8821 13.1672C77.9772 13.1672 78.4873 13.2796 78.4614 13.5216C78.4009 13.9712 78.3836 14.4294 78.349 14.9222C78.2107 14.9222 78.0983 14.9222 77.9859 14.9222C77.0349 14.8876 76.1184 15.026 75.2885 15.5361C74.104 16.2709 73.5075 17.3948 73.2654 18.7176C73.1617 19.2882 73.1271 19.8761 73.1184 20.4554C73.1012 21.7349 73.1098 23.0058 73.1098 24.2853C73.1011 24.3891 73.1011 24.5015 73.1011 24.6398Z"
                        fill="white"
                    />
                    <path
                        d="M108.79 13.2017H110.199C110.285 13.2017 110.363 13.2708 110.363 13.3659V24.4668C110.363 24.5532 110.294 24.6311 110.199 24.6311H108.79C108.703 24.6311 108.625 24.5619 108.625 24.4668V13.3659C108.625 13.2795 108.703 13.2017 108.79 13.2017Z"
                        fill="white"
                    />
                    <path
                        d="M89.0434 21.1729C88.7581 21.5966 88.4987 22.0548 88.1356 22.4006C86.3806 24.0346 82.6111 23.879 81.4699 20.5677C81.3316 20.1701 81.2278 19.7637 81.2538 19.3141C84.5045 19.3141 87.7293 19.3141 91.0059 19.3141C90.98 18.8732 90.98 18.4755 90.9368 18.0865C90.4613 13.9453 86.5708 12.0346 83.1039 13.4525C79.2567 15.026 78.712 19.634 80.4497 22.2969C81.7984 24.3631 83.7783 25.1672 86.199 24.8819C88.2826 24.6398 89.7696 23.5332 90.6169 21.6052C90.6515 21.5188 90.6861 21.4323 90.7293 21.3199C90.2624 21.2075 89.8302 21.1211 89.4065 21C89.2077 20.9568 89.1471 21.026 89.0434 21.1729ZM85.4728 14.5505C87.6688 14.585 88.9915 16.2277 89.1731 17.9827C86.5535 17.9827 83.9425 17.9827 81.3143 17.9827C81.4959 16.0548 83.3719 14.5245 85.4728 14.5505Z"
                        fill="white"
                    />
                    <path
                        d="M109.473 11.5417C108.781 11.5331 108.28 11.023 108.288 10.34C108.297 9.69161 108.842 9.18152 109.499 9.18152C110.173 9.19016 110.718 9.73483 110.709 10.3746C110.692 11.049 110.165 11.5504 109.473 11.5417Z"
                        fill="white"
                    />
                </g>
                <path
                    d="M8.23055 13.0635C7.46974 13.0635 7.26225 13.6514 7.09798 14.1182L4.58213 21.3718L2.08357 14.1615L2.06628 14.1182C1.90202 13.6514 1.69452 13.0635 0.933718 13.0635C0.345821 13.0635 0 13.513 0 13.9453C0 14.1528 0.0345821 14.343 0.112392 14.5851L3.48415 23.9914C3.59654 24.3286 3.82133 24.9597 4.59078 24.9597C5.36023 24.9597 5.57637 24.3286 5.68876 24.0001L9.06052 14.5851C9.13833 14.3517 9.17291 14.1615 9.17291 13.954C9.16426 13.513 8.81844 13.0635 8.23055 13.0635Z"
                    fill="#BFBFBF"
                />
                <path
                    d="M20.8704 13.9452C20.8704 14.2132 20.7667 14.4293 20.6024 14.6974L17.6888 19.4438V23.8962C17.6888 24.5273 17.2825 24.951 16.6773 24.951C16.0721 24.951 15.6658 24.5273 15.6658 23.8962V19.4438L12.7436 14.6974C12.5793 14.438 12.4756 14.2219 12.4756 13.9538C12.4756 13.4438 12.8819 13.0634 13.4266 13.0634C13.8416 13.0634 14.1528 13.2622 14.3949 13.6599L16.6773 17.3775L18.9597 13.6599C19.1932 13.2622 19.513 13.072 19.928 13.072C20.4641 13.0634 20.8704 13.4438 20.8704 13.9452Z"
                    fill="#BFBFBF"
                />
                <path
                    d="M34.3487 14.1181V23.8184C34.3487 24.804 33.7521 24.951 33.3977 24.951C32.7925 24.951 32.5158 24.6138 32.1613 24.0951L27.1383 16.8847V23.8876C27.1383 24.5187 26.732 24.9423 26.1268 24.9423C25.5216 24.9423 25.1152 24.5187 25.1152 23.8876V14.1959C25.1152 13.2103 25.7118 13.0634 26.0662 13.0634C26.6714 13.0634 26.9481 13.4005 27.3026 13.9193L32.3256 21.1296V14.1268C32.3256 13.4956 32.7319 13.072 33.3371 13.072C33.9423 13.0634 34.3487 13.487 34.3487 14.1181Z"
                    fill="#BFBFBF"
                />
                <path
                    d="M45.6052 23.9048C45.6052 24.4927 45.2161 24.8731 44.6109 24.8731H40.6859C40.0461 24.8731 39.6311 24.4495 39.6311 23.8011V14.2305C39.6311 13.5821 40.0461 13.1584 40.6859 13.1584H44.6109C45.2161 13.1584 45.6052 13.5389 45.6052 14.1267C45.6052 14.7146 45.2161 15.095 44.6109 15.095H41.6455V18.0518H44.3083C44.9135 18.0518 45.3026 18.4322 45.3026 19.0201C45.3026 19.608 44.9135 19.9884 44.3083 19.9884H41.6455V22.9452H44.6109C45.2161 22.9365 45.6052 23.3169 45.6052 23.9048Z"
                    fill="#BFBFBF"
                />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_743_4222"
                    x1="48.9658"
                    y1="32.3858"
                    x2="119.571"
                    y2="5.44057"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#1E4990" />
                    <stop offset="0.4923" stopColor="#347695" />
                    <stop offset="1" stopColor="#89BE42" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_743_4222"
                    x1="82.7974"
                    y1="46.4474"
                    x2="102.744"
                    y2="-1.55196"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#1E4990" />
                    <stop offset="0.49" stopColor="#347695" />
                    <stop offset="1" stopColor="#89BE42" />
                </linearGradient>
                <clipPath id="clip0_743_4222">
                    <rect width="132" height="32.1441" fill="white" />
                </clipPath>
                <clipPath id="clip1_743_4222">
                    <path
                        d="M51.3579 7.60807C51.3579 3.40625 54.7642 0 58.966 0H132.073V24.536C132.073 28.7378 128.666 32.1441 124.465 32.1441H51.3579V7.60807Z"
                        fill="white"
                    />
                </clipPath>
                <clipPath id="clip2_743_4222">
                    <rect width="63" height="14" fill="white" transform="translate(69 36)" />
                </clipPath>
            </defs>
        </svg>
    )
}

export function SimplifeyeLogoIconSmall(props: SvgIconProps) {
    return (
        <svg
            width="20px"
            height="20px"
            viewBox="0 0 42 43"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <title>E32FDFCE-0E76-4F3C-850B-32444E12B1D7</title>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="nav-viewport-1" transform="translate(-18.000000, -230.000000)" fill="#000000">
                    <g id="simplifeye-vyne-logo" transform="translate(18.000000, 230.000000)">
                        <path
                            d="M21.1396965,15.7012899 C18.220854,15.7012899 15.8538935,18.0615984 15.8538935,20.9727002 C15.8538935,23.8813468 18.220854,26.2441106 21.1396965,26.2441106 C24.0569038,26.2441106 26.4238644,23.8813468 26.4238644,20.9727002 C26.4238644,18.0615984 24.0569038,15.7012899 21.1396965,15.7012899 M19.7293314,21.5030331 C18.5617944,21.5030331 17.6158278,20.5569454 17.6158278,19.3915226 C17.6158278,18.2285551 18.5617944,17.2857411 19.7293314,17.2857411 C20.8968684,17.2857411 21.8444703,18.2285551 21.8444703,19.3915226 C21.8444703,20.5569454 20.8968684,21.5030331 19.7293314,21.5030331"
                            id="Fill-1"
                        ></path>
                        <path
                            d="M9.45647745,20.7797998 C9.45647745,27.2051752 14.6956771,32.4299359 21.1367532,32.4299359 C27.5810996,32.4299359 32.8219345,27.2051752 32.8219345,20.7797998 C32.8219345,15.3700773 29.0993883,10.8229642 24.0825766,9.51922922 L24.0825766,12.1201518 C27.699652,13.3453189 30.3192519,16.758109 30.3192519,20.7797998 C30.3192519,25.8286013 26.1960802,29.9296784 21.1367532,29.9296784 C16.0782437,29.9296784 11.9591601,25.8286013 11.9591601,20.7797998 C11.9591601,16.758109 14.5795775,13.3428636 18.1982882,12.1176965 L18.1982882,9.51759239 C13.1790237,10.8229642 9.45647745,15.3700773 9.45647745,20.7797998"
                            id="Fill-3"
                        ></path>
                        <path
                            d="M20.9899117,37.4604868 C30.1061845,37.4604868 37.5218433,30.0628345 37.5218433,20.9686081 C37.5218433,11.8792923 30.1061845,4.48655048 20.9899117,4.48655048 C12.9242586,4.48655048 6.20029195,10.2817464 4.75640515,17.9093732 L7.42260836,17.9093732 C8.821527,11.7270671 14.3705982,7.08992828 20.9899117,7.08992828 C28.6696561,7.08992828 34.9128723,13.3139736 34.9128723,20.9686081 C34.9128723,28.6289716 28.6696561,34.8562906 20.9899117,34.8562906 C14.3705982,34.8562906 8.82397981,30.2183333 7.42260836,24.0302983 L4.75640515,24.0302983 C6.20274476,31.659562 12.9283466,37.4604868 20.9899117,37.4604868"
                            id="Fill-5"
                        ></path>
                        <path
                            d="M18.0338682,41.9470373 L18.0338682,39.2569075 C9.31249757,37.7772134 2.64167512,30.2060571 2.64167512,21.0848231 C2.64167512,10.9143811 10.9411626,2.63529598 21.1383066,2.63529598 C31.3395386,2.63529598 39.6357557,10.9143811 39.6357557,21.0848231 C39.6357557,30.2060571 32.9682036,37.7788502 24.246833,39.2569075 L24.246833,41.9470373 C34.4341657,40.4362434 42.279066,31.6628356 42.279066,21.0848231 C42.279066,9.46251307 32.7932366,0 21.1383066,0 C9.48419419,0 0,9.46251307 0,21.0848231 C0,31.6628356 7.84653548,40.4362434 18.0338682,41.9470373"
                            id="Fill-7"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    )
}

export function VyneLogoIconSmall(props: SvgIconProps) {
    return (
        <svg
            width="18px"
            height="12px"
            viewBox="0 0 18 12"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <title>5EF437A8-67DB-4900-9D02-26FB645DD665</title>
            <defs>
                <polygon
                    id="path-1"
                    points="0 1.38160235e-15 5.66957611 1.38160235e-15 5.66957611 5.65985395 0 5.65985395"
                ></polygon>
                <polygon
                    id="path-3"
                    points="2.76320469e-15 0 5.66957611 0 5.66957611 5.65985395 2.76320469e-15 5.65985395"
                ></polygon>
                <polygon
                    id="path-5"
                    points="0 -1.38160235e-15 5.669965 -1.38160235e-15 5.669965 5.65962062 0 5.65962062"
                ></polygon>
            </defs>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="salesforce" transform="translate(-337.000000, -403.000000)">
                    <g id="Group-20" transform="translate(337.000000, 403.000000)">
                        <path
                            d="M12.330035,2.3694076 L10.6399343,0.679306918 C10.1872704,0.226643045 9.59382967,0.000311109191 8.99961111,0.000311109191 C8.40617033,0.000311109191 7.81272955,0.226643045 7.36006568,0.679306918 L5.669965,2.3694076 L8.99961111,5.66016506 L12.330035,2.3694076 Z"
                            id="Fill-1"
                            fill="#8ABF42"
                        ></path>
                        <g id="Group-5" transform="translate(0.000000, 5.659698)">
                            <mask id="mask-2" fill="white">
                                <use xlinkHref="#path-1"></use>
                            </mask>
                            <g id="Clip-4"></g>
                            <path
                                d="M0.679384695,1.70021173 C-0.226720823,2.60631724 -0.226720823,4.07475262 0.679384695,4.98085814 C1.58549021,5.88618589 3.05392559,5.88618589 3.96003111,4.98085814 L5.66957611,3.29075746 L2.37959642,1.38160235e-15 L0.679384695,1.70021173 Z"
                                id="Fill-3"
                                fill="#8ABF42"
                                mask="url(#mask-2)"
                            ></path>
                        </g>
                        <path
                            d="M15.6206369,5.65993173 L12.3298794,8.95068919 L14.0402022,10.6400121 C14.9463077,11.5461176 16.4147431,11.5461176 17.3208486,10.6400121 C18.2261764,9.73468435 18.2261764,8.2654712 17.3208486,7.36014346 L15.6206369,5.65993173 Z"
                            id="Fill-6"
                            fill="#8ABF42"
                        ></path>
                        <g id="Group-10" transform="translate(12.330424, 0.000233)">
                            <mask id="mask-4" fill="white">
                                <use xlinkHref="#path-3"></use>
                            </mask>
                            <g id="Clip-9"></g>
                            <path
                                d="M4.99019142,3.95964222 C5.89629694,3.05353671 5.89629694,1.58510133 4.99019142,0.678995809 C4.0840859,-0.226331936 2.61565052,-0.226331936 1.709545,0.678995809 L2.76320469e-15,2.36909649 L3.28997969,5.65985395 L4.99019142,3.95964222 Z"
                                id="Fill-8"
                                fill="#1D4890"
                                mask="url(#mask-4)"
                            ></path>
                        </g>
                        <path
                            d="M5.669965,8.95045586 L7.36006568,10.6405565 C7.81272955,11.0932204 8.40617033,11.3195523 9.00038889,11.3195523 C9.59382967,11.3195523 10.1872704,11.0932204 10.6399343,10.6405565 L12.330035,8.95045586 L9.00038889,5.6596984 L5.669965,8.95045586 Z"
                            id="Fill-11"
                            fill="#1D4890"
                        ></path>
                        <g id="Group-15" transform="translate(0.000156, 0.000000)">
                            <mask id="mask-6" fill="white">
                                <use xlinkHref="#path-5"></use>
                            </mask>
                            <g id="Clip-14"></g>
                            <path
                                d="M3.95964222,0.67954025 C3.05353671,-0.226565268 1.58510133,-0.226565268 0.678995809,0.67954025 C-0.226331936,1.58564577 -0.226331936,3.05408115 0.678995809,3.96018667 L2.37920754,5.65962062 L5.669965,2.36964093 L3.95964222,0.67954025 Z"
                                id="Fill-13"
                                fill="#1D4890"
                                mask="url(#mask-6)"
                            ></path>
                        </g>
                        <polygon
                            id="Fill-16"
                            fill="#317595"
                            points="5.669965 2.3694076 2.37920754 5.66016506 5.669965 8.95014475 9.00038889 5.66016506"
                        ></polygon>
                        <polygon
                            id="Fill-18"
                            fill="#317595"
                            points="12.330035 2.3694076 8.99961111 5.66016506 12.330035 8.95014475 15.6207925 5.66016506"
                        ></polygon>
                    </g>
                </g>
            </g>
        </svg>
    )
}
/* tslint:enable:max-line-length */
